export interface Category {
  id: string;
  category: string;
  name: string;
  icon?: string;
  iconColor?: string;
  backgroundColor?: string;
}

export interface Wallet {
  title: string;
  id: string;
  wallet: {
    id: string;
    name: string;
    balance: number;
    type: string;
  };
}

export enum TransactionType {
  EXPENSE = 0,
  INCOME = 1,
  LOAN = 2,
  TRANSFER = 3,
  CREDIT_CARD = 4,
}

export interface TransactionFormProps {
  isDrawer?: boolean;
  handleCloseDrawer?: () => void;
} 